import { RemoteGetUsersOnlineMaps } from 'data/usecases';
import { makeApiUrlUsersOnlineMaps } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetUsersOnlineMaps = (): RemoteGetUsersOnlineMaps => {
  return new RemoteGetUsersOnlineMaps(
    makeApiUrlUsersOnlineMaps(),
    makeAxiosHttpClient(),
  );
};
